import styles from './DiscountPill.module.css';

export type DiscountPillProps = {
  children: React.ReactNode;
  className?: string;
};

export const DiscountPill = ({ children, className }: DiscountPillProps) => (
  <span className={className ? `${styles.pill} ${className}` : styles.pill}>
    {children}
  </span>
);
